import React, { useState } from 'react'
import { useThemeContext } from '../../theme/ThemeContext'
import NeutralMark from '../NeutralAuth/NeutralMark'
import { NEUTRAL_MARK_COLORS } from '../NeutralAuth/palette'
import { CLIENT_PORTAL_LABEL } from '../../lib/portalAudience'
import { PORTAL_BRAND_STATUS } from './portalBrandStatus'

const BRAND_AREA = 'flex items-center gap-2.5 mr-6 shrink-0 min-h-[36px]'

const FIRM_AREA = 'flex items-center gap-2.5 mr-6 min-w-0 min-h-[36px]'

const NeutralBrand = () => {
  const { mode } = useThemeContext()

  return (
    <div className={BRAND_AREA}>
      <span className="flex" style={NEUTRAL_MARK_COLORS[mode === 'dark' ? 'dark' : 'light']}>
        <NeutralMark size={36} />
      </span>
      <span className="text-[16px] font-bold tracking-tight text-text-primary">{CLIENT_PORTAL_LABEL}</span>
    </div>
  )
}

const FirmMark = ({ brand }) => {
  const { mode } = useThemeContext()
  const [failedMarks, setFailedMarks] = useState([])
  const [failedLogo, setFailedLogo] = useState(null)
  const markUrl = mode === 'dark' ? brand.markUrl : (brand.markUrlLight || brand.markUrl)
  const showMark = Boolean(markUrl) && !failedMarks.includes(markUrl)
  const logoUrl = mode === 'dark' && brand.logoUrlDark ? brand.logoUrlDark : brand.logoUrl
  const showLogo = !showMark && Boolean(logoUrl) && failedLogo !== logoUrl
  const showPicture = showMark || showLogo

  return (
    <div className={FIRM_AREA}>
      {showMark && (
        <img
          src={markUrl}
          alt={brand.name}
          className="h-9 w-9 shrink-0 object-contain"
          onError={() => setFailedMarks((failed) => [...failed, markUrl])}
        />
      )}
      {showLogo && (
        <img
          src={logoUrl}
          alt={brand.name}
          className="h-9 w-auto max-w-[8rem] sm:max-w-[10rem] shrink-0 object-contain"
          onError={() => setFailedLogo(logoUrl)}
        />
      )}
      <span
        aria-hidden={showPicture ? 'true' : undefined}
        className={`${showPicture ? 'hidden sm:block' : 'block'} max-w-[16rem] truncate text-[16px] font-extrabold tracking-tight text-text-primary`}
      >
        {brand.name}
      </span>
    </div>
  )
}

const PortalBrandMark = ({ portalBrand }) => {
  if (portalBrand?.status === PORTAL_BRAND_STATUS.FIRM) return <FirmMark brand={portalBrand.brand} />
  if (portalBrand?.status === PORTAL_BRAND_STATUS.NEUTRAL) return <NeutralBrand />
  return <div className={BRAND_AREA} />
}

export default PortalBrandMark
